import React from "react";
import {
  FiMapPin,
  FiMaximize2,
  FiDroplet,
  FiArrowUpRight,
} from "react-icons/fi";
import { FaBed } from "react-icons/fa";
import "./PropertyCard.css";
import apis from "../../utils/apis";
import converPrice from "../../utils/convertAmount";
import { useNavigate } from "react-router-dom";
import httpAction from "../../utils/httpAction";

// ✅ MUI Skeleton
import { Skeleton } from "@mui/material";

export default function PropertyCard({ item, loading = false }) {
  const navigate = useNavigate();

  const visitHandler = async () => {
    const data = {
      url: apis().lisitingAddVisit + "?id=" + item?._id,
      method: "PUT",
    };
    await httpAction(data);
  };

  // If you don't pass loading, auto-detect from item
  const isLoading =
    loading ||
    !item ||
    !item?.data ||
    !item?.data?.title ||
    !item?.data?.images;

  // ✅ Skeleton UI
  if (isLoading) {
    return (
      <div className="pc">
        <div className="pc__media">
          <Skeleton variant="rectangular" width="100%" height={220} />

          <div className="pc__priceRow" style={{ marginTop: 12 }}>
            <Skeleton variant="text" width="50%" height={28} />
            <Skeleton variant="rounded" width={80} height={28} />
          </div>
        </div>

        <div className="pc__body">
          <Skeleton variant="text" width="85%" height={30} />

          <div className="pc__loc" style={{ marginTop: 8 }}>
            <Skeleton variant="text" width="65%" height={22} />
          </div>

          <div
            className="pc__meta"
            style={{ marginTop: 10, display: "flex", gap: 12 }}
          >
            <Skeleton variant="rounded" width={90} height={26} />
            <Skeleton variant="rounded" width={90} height={26} />
            <Skeleton variant="rounded" width={90} height={26} />
          </div>

          <div className="pc__actions" style={{ marginTop: 14 }}>
            <Skeleton variant="rounded" width="100%" height={44} />
          </div>
        </div>
      </div>
    );
  }

  // ✅ Normal UI
  return (
    <div className="pc">
      <div className="pc__media">
        <img
          className="pc__img"
          src={apis().localUrl + item?.data?.images?.[0]?.url}
          alt={item?.data?.title}
        />

        <span className="pc__badge">Verified</span>

        <div className="pc__priceRow">
          <span className="pc__price">
            PKR: {converPrice(item?.data?.price)}
          </span>
          <span className="pc__pill">{item?.data?.type}</span>
        </div>
      </div>

      <div className="pc__body">
        <h3 className="pc__title">{item?.data?.title}</h3>

        <div className="pc__loc">
          <FiMapPin />
          <span>{item?.data?.location}</span>
        </div>

        <div className="pc__meta">
          {item?.data?.type === "residential" && (
            <>
              <span className="pc__metaItem">
                <FaBed /> {item?.data?.bed} Beds
              </span>

              <span className="pc__metaItem">
                <FiDroplet /> {item?.data?.bath} Baths
              </span>
            </>
          )}
          <span className="pc__metaItem">
            <FiMaximize2 /> {item?.data?.size}
          </span>
        </div>

        <div className="pc__actions">
          <button
            onClick={() => {
              window.scroll({ top: 0, behavior: "smooth" });
              visitHandler();

              if (item?.data?.type === "project") {
                navigate(`/project/detail?id=${item?._id}`);
              } else {
                navigate(`/properties/detail?id=${item?._id}`);
              }
            }}
            className="pc__btn pc__btn--primary"
            type="button"
          >
            View Details <FiArrowUpRight />
          </button>
        </div>
      </div>
    </div>
  );
}
